import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "./AuthProvider";

/** Sperrt alle darunterliegenden Routen, bis eine Sitzung besteht. */
export function RequireAuth() {
  const { authenticated, checking } = useAuth();
  const location = useLocation();

  if (checking) {
    return <p className="centered muted">Sitzung wird geprüft …</p>;
  }

  if (!authenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
